import { useState, useEffect, useCallback } from 'react';
import { botConfigured, claudeConfigured } from '../services/telegramBot';
import { connectionLog } from '../services/connectionLog';
import type { ConnectionLogEntry } from '../services/connectionLog';
import type { BotSystemState } from '../services/telegramBot';

const STORAGE_KEY = 'telegram_bot_enabled';

export function useTelegramBot(_state: BotSystemState) {
  const [enabled, setEnabled] = useState<boolean>(
    () => localStorage.getItem(STORAGE_KEY) === '1'
  );
  const [log, setLog] = useState<ConnectionLogEntry[]>(() => connectionLog.getAll());

  useEffect(() => {
    return connectionLog.subscribe(() => setLog([...connectionLog.getAll()]));
  }, []);

  const toggle = useCallback(() => {
    setEnabled(prev => {
      const next = !prev;
      localStorage.setItem(STORAGE_KEY, next ? '1' : '0');
      return next;
    });
  }, []);

  const clearLog = useCallback(() => connectionLog.clear(), []);

  return {
    enabled,
    toggle,
    log,
    clearLog,
    botConfigured,
    claudeConfigured,
  };
}
